import type * as React from "react";

import { Typography } from "components/ui/Typography";

import { cn } from "@/lib/utils";

type TProps = { onClick: () => void; prefix: React.ReactNode; selected?: boolean };

export const SelectionOption: FC<TProps> = ({ children, onClick, prefix, selected }) => {
  return (
    <button
      className={cn(
        "flex w-full items-center justify-start gap-3 px-4 py-3 min-h-13 cursor-pointer transition-colors duration-200 ease-in-out bg-transparent border-none text-foreground text-left hover:bg-primary/10",
        selected && "bg-primary/10",
      )}
      onClick={onClick}
      type="button"
    >
      {prefix && <div className="flex items-center justify-center w-[1em] text-[1.25em]">{prefix}</div>}

      <Typography noWrap variant="text_reg">
        {children}
      </Typography>
    </button>
  );
};
